import { render, staticRenderFns } from "./SaleCard.vue?vue&type=template&id=ec4eb976&"
import script from "./SaleCard.vue?vue&type=script&lang=js&"
export * from "./SaleCard.vue?vue&type=script&lang=js&"
import style0 from "./SaleCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports